export const capitalizeEachWord = (sentence: string | null | undefined) => {
  if (!sentence) {
    return "";
  }
  const capitalizeNonPrepositionWord = (word: string) => {
    if (/^(?:of|on|at|in|to|by|against|with(?:in)?)$/i.test(word)) {
      return word.toLowerCase();
    }
    return word.charAt(0).toUpperCase() + word.substring(1).toLowerCase();
  };
  return sentence.split(/\s+/).map(capitalizeNonPrepositionWord).join(" ");
};

/**
 * Formats text with proper pluralization using Intl.PluralRules
 * @param count - The number to determine singular/plural form
 * @param word - The base word to pluralize
 * @returns Formatted string with count and properly pluralized word
 */
export const formatCountText = (count: number, word: string): string => {
  const pluralRules = new Intl.PluralRules("en-US");
  const pluralForm = pluralRules.select(count);
  return `${count} ${word}${pluralForm === "one" ? "" : "s"}`;
};
